class PivotRutInput extends HTMLElement {
  constructor() {
    super()
    this.$input = this.querySelector('input')
    import('./rut.js').then(({ validate: validateRut, format: formatRut }) => {
      const validator = () => {
        const isValid = validateRut(this.$input.value)
        this.$input.classList.add('is-invalid', isValid)
        if (isValid) this.$input.removeAttribute('pattern')
        else
          this.$input.setAttribute('pattern', [
            '!/^0*(d{1,3}(.?d{3})*)-?([dkK])$/',
          ])
        this.$input.ariaInvalid = !isValid
      }
      this.addEventListener('keyup', validator)
      this.addEventListener('blur', e => {
        this.$input.value = formatRut(this.$input.value)
      })
    })
  }
}
if (!customElements.get('pivot-rut-input')) {
  customElements.define('pivot-rut-input', PivotRutInput)
}

